/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { minoriService } from '@/services';
import get from 'lodash/get';

export const state = {
  all: null,
  detail: {},
  exceptions: {},
  listOfChildren: {},
  classroomParents: {},
};

export const getters = {
  getClassName: state => (route) => {
    if (route.query && route.query.classe) {
      return route.query.classe;
    }
    return get(state, ['detail', 'minor', 'classroom'])
      ? get(state, ['detail', 'minor', 'classroom']).class_name
      : '';
  },
  listOfChildren: state => get(state.listOfChildren, ['items', 'data']) || [],
  childrenCount: state => get(state.listOfChildren, ['items', 'count']) || {},
  classroomParents: state => state.classroomParents,
  users: state => get(state, ['all']) || [],
  minorEvents: state => get(state, ['all', 'events']) || [],
  kids: state => get(state, ['all', 'items']) || [],
  kidsOther: (state, getters) => getters.kids.filter(kid => !kid.isFamilyAdmin),
  kidsMy: (state, getters) => getters.kids.filter(kid => kid.isFamilyAdmin),
  minor: state => get(state, ['detail', 'minor']) || {},
  genitori: (state, getters) => get(getters.minor, ['family']) || [],
  isFamilyAdmin: (state, getters) => !!getters.minor.isFamilyAdmin,
  getException: state => get(state, ['exceptions', 'exc', 'data', '0']) || null,
  getDateException: (state, getters) => {
    if (getters.getException) {
      const ar = getters.getException.arrival_time.split(':');
      return ar[0] + ':' + ar[1];
    }
    return '';
  },
};

export const actions = {
  init({ state }) {
    state.all = null;
    state.detail = {};
    state.exceptions = {};
    state.listOfChildren = {};
    state.classroomParents = {};
  },
  getAll({ commit, dispatch }) {
    minoriService
      .getAll()
      .then((response) => {
        commit('getAllSuccess', response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  addArrivalExc({ commit, dispatch }, { id, classroom, arrival }) {
    dispatch('setClassroom', classroom, { root: true });
    return minoriService
      .addArrivalExc(id, classroom, arrival)
      .then((response) => {
        commit('getException', response.data);
        return true;
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  updateArrivalExc({ commit, dispatch }, { excId, arrival }) {
    minoriService
      .updateArrivalExc(excId, arrival)
      .then((response) => {
        commit('updateException', response.data);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  getAllByClass({ commit, dispatch }, { id }) {
    dispatch('setClassroom', id, { root: true });
    minoriService.getAllByClass(id).then((response) => {
      commit('getListOfChildren', response);
    });
  },
  getRollCallByClass({ commit, dispatch }, { id }) {
    dispatch('setClassroom', id, { root: true });
    minoriService
      .getRollCallByClass(id)
      .then((response) => {
        commit('getListOfChildren', response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  getChildrenInClass({ commit, dispatch }, { id }) {
    dispatch('setClassroom', id, { root: true });
    minoriService
      .getChildrenInClass(id)
      .then((response) => {
        commit('getListOfChildren', response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  async getMinor({ commit, dispatch }, { id, role }) {
    let response = null;
    try {
      response = await minoriService.getMinor(id, role);
      commit('getMinorSuccess', response);
      dispatch('setClassroom', response.classroom.id, { root: true });
    } catch (error) {
      dispatch(
        'notificationService',
        { type: error, text: error },
        { root: true },
      );
    }

    try {
      if (role === 'tutor') {
        const response2 = await minoriService.getArrivalExc(
          id,
          response.classroom.id,
        );
        commit('getException', response2);
      }
    } catch (error) {
      dispatch(
        'notificationService',
        { type: error, text: error },
        { root: true },
      );
    }
  },
  updateMinor({ commit }, { user }) {
    minoriService.updateMinor(user);
  },
  changeMinorStatus({ commit, dispatch }, { id, classroom }) {
    dispatch('setClassroom', classroom, { root: true });
    minoriService
      .changeMinorStatus(id, classroom)
      .then((resp) => {
        minoriService
          .getRollCallByClass(classroom)
          .then((response) => {
            commit('getAllSuccess', response.data);
          })
          .catch((error) => {
            dispatch(
              'notificationService',
              { type: 'error', text: error },
              { root: true },
            );
          });
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  confirmLeftAction({ commit, dispatch }, { id, classroom }) {
    dispatch('setClassroom', classroom, { root: true });
    minoriService
      .confirmLeft(id, classroom)
      .then((resp) => {
        minoriService
          .getChildrenInClass(classroom)
          .then((response) => {
            commit('getAllSuccess', response.data);
          })
          .catch((error) => {
            dispatch(
              'notificationService',
              { type: 'error', text: error },
              { root: true },
            );
          });
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  confirmAbsenceAction({ commit, dispatch }, { id, classroom }) {
    dispatch('setClassroom', classroom, { root: true });
    minoriService
      .confirmAbsence(id, classroom)
      .then((resp) => {
        minoriService
          .getRollCallByClass(classroom)
          .then((response) => {
            commit('getAllSuccess', response.data);
          })
          .catch((error) => {
            dispatch(
              'notificationService',
              { type: 'error', text: error },
              { root: true },
            );
          });
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  showClassroomParents({ commit, dispatch }, { id, classroom }) {
    dispatch('setClassroom', classroom, { root: true });
    minoriService
      .showClassroomParents(id, classroom)
      .then((response) => {
        commit('showClassroomParents', response.data);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  async getMinorsEvent({ commit, dispatch }, { classroomId, date }) {
    dispatch('setClassroom', classroomId, { root: true });
    try {
      const response = await minoriService.getMinorsEvent(classroomId, date);
      commit('GET_MINORS_EVENT', response);
    } catch (error) {
      dispatch(
        'notificationService',
        { type: 'error', text: error },
        { root: true },
      );
    }
  },
};

export const mutations = {
  getException(state, exc) {
    state.exceptions = {
      exc,
    };
  },
  getAllSuccess(state, users) {
    state.all = {
      items: users,
    };
  },
  getListOfChildren(state, { data }) {
    state.listOfChildren = {
      items: data,
    };
  },
  updateException(state, exc) {
    state.exceptions = {
      exc,
      update: 'updated',
    };
  },
  getMinorSuccess(state, users) {
    state.detail = {
      minor: users,
    };
  },
  showClassroomParents(state, data) {
    state.classroomParents = data;
  },
  GET_MINORS_EVENT(state, data) {
    state.all = {
      events: data,
    };
  },
};
